export const VeganIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3636 4.72726H5.30297C4.82682 4.72726 4.43933 5.11475 4.43933 5.5909C4.43933 6.06705 4.82682 6.45454 5.30297 6.45454H13.3636C13.8397 6.45454 14.2272 6.06705 14.2272 5.5909C14.2272 5.11475 13.8397 4.72726 13.3636 4.72726ZM13.3636 5.87878H5.30297C5.14435 5.87878 5.01509 5.74981 5.01509 5.5909C5.01509 5.43199 5.14435 5.30302 5.30297 5.30302H13.3636C13.5222 5.30302 13.6515 5.43199 13.6515 5.5909C13.6515 5.74981 13.5222 5.87878 13.3636 5.87878Z"
          fill={fill}
        />
        <path
          d="M11.3485 7.60599H6.16672C6.00781 7.60599 5.87885 7.73467 5.87885 7.89387C5.87885 8.05306 6.00781 8.18175 6.16672 8.18175H11.3485C11.5075 8.18175 11.6364 8.05306 11.6364 7.89387C11.6364 7.73467 11.5075 7.60599 11.3485 7.60599Z"
          fill={fill}
        />
        <path
          d="M6.74241 9.04539H9.04544C9.20435 9.04539 9.33332 8.91671 9.33332 8.75751C9.33332 8.59832 9.20435 8.46964 9.04544 8.46964H6.74241C6.5835 8.46964 6.45453 8.59832 6.45453 8.75751C6.45453 8.91671 6.5835 9.04539 6.74241 9.04539Z"
          fill={fill}
        />
        <path
          d="M6.74241 9.90901H7.89392C8.05283 9.90901 8.1818 9.78033 8.1818 9.62113C8.1818 9.46193 8.05283 9.33325 7.89392 9.33325H6.74241C6.5835 9.33325 6.45453 9.46193 6.45453 9.62113C6.45453 9.78033 6.5835 9.90901 6.74241 9.90901Z"
          fill={fill}
        />
        <path
          d="M11.3485 11.0605H6.16672C6.00781 11.0605 5.87885 11.1892 5.87885 11.3484C5.87885 11.5076 6.00781 11.6363 6.16672 11.6363H11.3485C11.5075 11.6363 11.6364 11.5076 11.6364 11.3484C11.6364 11.1892 11.5075 11.0605 11.3485 11.0605Z"
          fill={fill}
        />
        <path
          d="M6.74241 12.4999H8.46968C8.62859 12.4999 8.75756 12.3712 8.75756 12.212C8.75756 12.0528 8.62859 11.9242 8.46968 11.9242H6.74241C6.5835 11.9242 6.45453 12.0528 6.45453 12.212C6.45453 12.3712 6.5835 12.4999 6.74241 12.4999Z"
          fill={fill}
        />
        <path
          d="M6.74241 13.3636H8.46968C8.62859 13.3636 8.75756 13.2349 8.75756 13.0757C8.75756 12.9165 8.62859 12.7878 8.46968 12.7878H6.74241C6.5835 12.7878 6.45453 12.9165 6.45453 13.0757C6.45453 13.2349 6.5835 13.3636 6.74241 13.3636Z"
          fill={fill}
        />
        <path
          d="M11.0606 14.8031H5.87876C5.71985 14.8031 5.59088 14.9318 5.59088 15.091C5.59088 15.2502 5.71985 15.3789 5.87876 15.3789H11.0606C11.2195 15.3789 11.3485 15.2502 11.3485 15.091C11.3485 14.9318 11.2195 14.8031 11.0606 14.8031Z"
          fill={fill}
        />
        <path
          d="M6.4545 16.2425H8.18178C8.34069 16.2425 8.46966 16.1138 8.46966 15.9546C8.46966 15.7954 8.34069 15.6667 8.18178 15.6667H6.4545C6.2956 15.6667 6.16663 15.7954 6.16663 15.9546C6.16663 16.1138 6.2956 16.2425 6.4545 16.2425Z"
          fill={fill}
        />
        <path
          d="M6.4545 17.1061H7.03026C7.18917 17.1061 7.31814 16.9774 7.31814 16.8182C7.31814 16.659 7.18917 16.5304 7.03026 16.5304H6.4545C6.2956 16.5304 6.16663 16.659 6.16663 16.8182C6.16663 16.9774 6.2956 17.1061 6.4545 17.1061Z"
          fill={fill}
        />
        <path
          d="M11.0606 18.5454H5.87876C5.71985 18.5454 5.59088 18.6741 5.59088 18.8333C5.59088 18.9925 5.71985 19.1212 5.87876 19.1212H11.0606C11.2195 19.1212 11.3485 18.9925 11.3485 18.8333C11.3485 18.6741 11.2195 18.5454 11.0606 18.5454Z"
          fill={fill}
        />
        <path
          d="M8.75754 19.4091H6.4545C6.2956 19.4091 6.16663 19.5378 6.16663 19.697C6.16663 19.8562 6.2956 19.9848 6.4545 19.9848H8.75754C8.91644 19.9848 9.04541 19.8562 9.04541 19.697C9.04541 19.5378 8.91644 19.4091 8.75754 19.4091Z"
          fill={fill}
        />
        <path
          d="M21.7121 4.43939C20.1121 4.43939 18.7156 5.31598 17.9697 6.6123V4.43939C17.9697 3.64571 17.324 3 16.5303 3H4.43939C3.64571 3 3 3.64571 3 4.43939V20.5606C3 21.3543 3.64571 22 4.43939 22H16.5303C17.324 22 17.9697 21.3543 17.9697 20.5606V17.0891C19.2631 16.9454 20.2727 15.8466 20.2727 14.5152V13.9394C20.2727 13.7802 20.1438 13.6515 19.9848 13.6515C19.1713 13.6515 18.445 14.0292 17.9697 14.6176V14.2273V10.758C20.2166 10.6089 22 8.73858 22 6.45455V4.72727C22 4.56808 21.871 4.43939 21.7121 4.43939ZM19.697 14.2477V14.5152C19.697 15.5288 18.945 16.3697 17.9697 16.5099V16.2424C17.9697 15.2288 18.7216 14.3879 19.697 14.2477ZM17.3939 14.499C16.1002 14.3554 15.0909 13.2557 15.0909 11.9242V11.6525C16.3846 11.7961 17.3939 12.8958 17.3939 14.2273V14.499ZM14.803 11.0606C14.6441 11.0606 14.5152 11.1893 14.5152 11.3485V11.9242C14.5152 13.5732 15.7824 14.9303 17.3939 15.0762V16.8182V20.5606C17.3939 21.0368 17.0065 21.4242 16.5303 21.4242H4.43939C3.96324 21.4242 3.57576 21.0368 3.57576 20.5606V4.43939C3.57576 3.96324 3.96324 3.57576 4.43939 3.57576H16.5303C17.0065 3.57576 17.3939 3.96324 17.3939 4.43939V12.4122C16.8205 11.5963 15.8739 11.0606 14.803 11.0606ZM21.4242 6.45455C21.4242 8.42133 19.8993 10.0383 17.9697 10.186V8.75758C17.9697 6.79079 19.4946 5.17377 21.4242 5.02609V6.45455Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
